<script>
  import { TreeBuilder } from "../models/TreeBuilder";
  import { colors } from "../utils/colors.ts";

  export let searchManager;
  export let formatManager;
  export let onFocus;
  export let onBlur;
  export let stree;
  export let targetId;
  export let query;
  export let oldInput;
  export let tree;
  export let searchField;
  export let params;
  export let builder;
  let input;

  setTimeout(() => {
    if (!isNaN(parseInt(oldInput.value))) {
      if (!params) return;
      for (const p of params[0].data) {
        if (p.id === parseInt(oldInput.value)) {
          searchField.value = p.name;
          searchField.dispatchEvent(new Event("keyup"));
          break;
        }
      }
    }
  });

  let isValid;
  let oldVal = "";
  let isLongQuery = false;
  async function changeHundler(e) {
    builder.clearTree();
    query = e.currentTarget.value;
    oldVal = query;

    oldInput.value = "";
    isValid = false;
    if (params) {
      targetId.subscribe((id) => {
        for (const un of params[0].data) {
          if (un.id.toString() === id) {
            oldInput.value = un.id;
            isValid = true;
            break;
          }
        }
      });
    }

    (async () => {
      if (query.length < 4) {
        stree.set({
          tree: builder.formatTree(formatManager.getTree()),
          value: query,
        });
        isLongQuery = false;
      } else {
        isLongQuery = true;
        let searchLast;
        let isSearch = true;
        (async () => {
          while (true) {
            if (isLongQuery === false) {
              return;
            }
            if (searchLast) {
              stree.set({ tree: searchLast, value: query });
              searchLast = undefined;
            }
            if (isSearch === false) break;
            await new Promise((resolve) => setTimeout(resolve, 300));
          }
        })();

        stree.set({ tree: {}, value: query });
        for await (const part of searchManager.search(query)) {
          if (part) {
            if (query.length > 3) {
              const tree = builder.mergeTree(part);
              searchLast = tree;
            }
          }
        }
        isSearch = false;
      }
    })();
  }
</script>

<input
  style="--veryLightGreen: {colors.veryLightGreen};"
  class="{isValid ? 'isValid' : ''} form-control"
  bind:this={searchField}
  on:focus={onFocus}
  on:blur={onBlur}
  on:keyup={changeHundler}
  on:mousedown={() => {
    if (!tree || !tree.tree) {
      changeHundler({ currentTarget: { value: oldVal } });
    }
  }}
  type="text"
/>

<style>
  input.isValid {
    background-color: var(--veryLightGreen);
  }
</style>
